export const queryKeys = {
  CRM_SETTINGS: 'CRM_SETTINGS',
  CRM_SETTINGS_COMPACT: 'CRM_SETTINGS_COMPACT'
};
